import { Button } from "@/components/ui/button";
import { PenSquare, Save, Loader2 } from "lucide-react";
import { ImageUpload } from "./ImageUpload";

interface ProfileHeaderProps {
  profile: any;
  isEditing: boolean;
  isLoading: boolean;
  setIsEditing: (value: boolean) => void;
  onSubmit: () => void;
}

export function ProfileHeader({ profile, isEditing, isLoading, setIsEditing, onSubmit }: ProfileHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <div className="flex items-center gap-4">
        <ImageUpload profile={profile} isEditing={isEditing} />
        <div className="space-y-1">
          <h2 className="text-2xl font-bold tracking-tight">
            {profile?.full_name || 'User'}
          </h2>
          <p className="text-sm text-muted-foreground">
            {profile?.email || 'No email provided'}
          </p>
          <p className="text-sm font-medium text-primary">
            Client ID: {profile?.client_number || 'N/A'}
          </p>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full sm:w-auto">
        <Button 
          type="button" 
          variant={isEditing ? "outline" : "default"}
          onClick={() => setIsEditing(!isEditing)}
          className="w-full sm:w-auto transition-all duration-200"
        >
          <PenSquare className="mr-2 h-4 w-4" />
          {isEditing ? "Cancel Editing" : "Edit Profile"}
        </Button>
        {isEditing && (
          <Button 
            type="submit"
            disabled={isLoading}
            onClick={onSubmit}
            className="w-full sm:w-auto"
          >
            {isLoading ? (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            ) : (
              <Save className="mr-2 h-4 w-4" />
            )}
            Save Changes
          </Button>
        )}
      </div>
    </div>
  );
}